import { useMemo } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Alert, AlertTitle, Link, Stack } from "@mui/material";
import { User } from "features/auth/types/user";

type PendingUsersProps = {
  users: User[];
};

const PendingUsers: React.FC<PendingUsersProps> = (props) => {
  const { users } = props;

  const pendingUsers = useMemo(() => {
    return users.filter((user) => user.state === "PENDING");
  }, [users]);

  if (pendingUsers.length === 0) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ my: 1 }}>
      <AlertTitle>Väntar på godkännande ({pendingUsers.length} st)</AlertTitle>

      <Stack>
        {pendingUsers.map((user) => {
          return (
            <Link key={user.id} component={RouterLink} to={`/users/view/${user.id}`}>
              {user.userName}
            </Link>
          );
        })}
      </Stack>
    </Alert>
  );
};

export default PendingUsers;
